import React from 'react';

import { Box, Link, Text } from '@betterment/samba-react';

import type { FourOhOneKPlanSupportResource } from './types';

export const PlanSupportAgentDetails: React.FC<{ agent: NonNullable<FourOhOneKPlanSupportResource['agent']> }> = ({
  agent,
}) => (
  <Box>
    <Text as="p" css={{ mb: 'space.100' }}>
      Your Client Success Manager: {agent.name}
    </Text>
    {agent.contactUrl && (
      <Text as="p" css={{ mb: 'space.0' }}>
        <Link href={agent.contactUrl} target="_blank" rel="noopener noreferrer">
          Schedule a call
        </Link>
      </Text>
    )}
    {agent.email && (
      <Text as="p">
        <Link href={`mailto:${agent.email}`}>{agent.email}</Link>
      </Text>
    )}
  </Box>
);
